import { FeaturesConfig } from "../FeaturesProvider";
import { ErrorCode, ErrorSeverity, FlexSdkErrorMetadata } from "~/modules/error";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { FeaturesServiceImpl } from "~/backend/generated/Features/api/features.service";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";

const metadata: FlexSdkErrorMetadata = {
    module: "config",
    severity: ErrorSeverity.Error,
    source: "FeaturesProviderImpl.ts"
};

export const featuresProviderImpl =
    (ctx: ContextManager) =>
    async (sessionToken: string, uiVersion?: string): Promise<FeaturesConfig> => {
        const featuresService = ctx.retrieveInstanceOf(ContextInstance.FeaturesServiceImpl, FeaturesServiceImpl);

        let featuresData: FeaturesConfig;

        try {
            featuresData = await featuresService.fetchFeatures({
                token: sessionToken,
                
                ...(uiVersion && { headers: { "X-Flex-Version": uiVersion } })
            });
        } catch (err) {
            const errorMsg = `featuresProvider: Failed to fetch features for UI version ${uiVersion}`;
            return throwFlexSdkError(ctx)(ErrorCode.FailedToFetchFeatures, metadata, errorMsg, err);
        }
        return featuresData;
    };
